<template>
  <v-row>
    <v-col>
      <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="pagination.itemsPerPage"
          :server-items-length="pagination.totalCount"
          :sort-by.sync="pagination.sortBy"
          :sort-desc.sync="pagination.sortDesc"
          :item-key="itemKey"
          :class="tClass"
          :hide-default-footer="hideDefaultFooter"
          disable-sort-by
          :single-expand="singleExpand"
          :show-expand="showExpand"
          :expanded.sync="expanded"
          :group-by="groupBy"
          :show-group-by="showGroupBy"
          :locale="systemLocale"
          :loading="loading"
          :height="!pagination.totalCount && hideIfEmpty
            ? 0
            : null">
        <template v-slot:progress>
          <v-progress-linear :active="loading" color="loader" height="5" indeterminate />
        </template>
        <!-- pass through scoped slots -->
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
          <slot :name="scopedSlotName" v-bind="slotData" />
        </template>

        <!-- pass through normal slots -->
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
          <slot :name="slotName" />
        </template>
      </v-data-table>
      <table-pagination v-if="pagination.totalCount" v-model="pagination" @changed="updatePagination" />
    </v-col>
  </v-row>
</template>

<script>
  import TablePagination from './TablePagination.vue'

  export default {
    components: {
      TablePagination
    },
    props: {
      headers: {
        type: Array,
        require: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        require: true
      },
      itemKey: {
        type: String,
        default: ''
      },
      tClass: {
        type: String,
        default: 'elevation-1 mb-4'
      },
      hideDefaultFooter: {
        type: Boolean,
        default: true
      },
      singleExpand: {
        type: Boolean,
        default: false
      },
      showExpand: {
        type: Boolean,
        default: false
      },
      expandAll: {
        type: Boolean,
        default: false
      },
      groupBy: {
        type: String
      },
      showGroupBy: {
        type: Boolean,
        default: false
      },
      hideIfEmpty: {
        type: Boolean,
        default: false
      },
      totalCount: {
        type: Number,
        default: 0
      },
      itemsPerPage: {
        type: Number,
        default: 10
      },
      requestMethod: {
        type: [Function, Promise],
        require: true
      }
    },
    data () {
      return {
        expanded: [],
        pagination: {
          page: 1,
          itemsPerPage: 10,
          totalCount: 0,
          sortBy: [],
          sortDesc: []
        },
        params: {
          offset: 0,
          limit: 10,
          orderBy: '',
          orderDir: ''
        }
      }
    },
    watch: {
      totalCount (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.pagination.totalCount = newVal
        }
      },
      expandAll (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.expanded = this.items
        }
      }
    },
    created () {
      this.pagination.itemsPerPage = this.itemsPerPage
      this.getDataFromServer()
    },
    methods: {
      resetPaginationAndGetDataFromServer: async function () {
        this.pagination.page = 1
        this.params.offset = 0
        await this.getDataFromServer()
      },
      getDataFromServer: async function () {
        await this.requestMethod(this.params)
      },
      updatePagination: async function (pagination) {
        const { sortBy, sortDesc, page, itemsPerPage } = pagination
        this.params.orderBy = sortBy[0]
          ? sortBy[0]
          : ''
        this.params.orderDir = !this.params.orderBy
          ? ''
          : sortDesc[0]
            ? 'desc'
            : 'asc'
        this.params.limit = itemsPerPage === -1
          ? 0
          : itemsPerPage
        this.params.offset = page === 1 || itemsPerPage === -1 || itemsPerPage >= this.totalCount
          ? 0
          : (page - 1) * itemsPerPage
        await this.getDataFromServer()
      }
    }
  }
</script>
